import { render, staticRenderFns } from "./LockCoach.vue?vue&type=template&id=94eb454e&"
import script from "./LockCoach.vue?vue&type=script&lang=js&"
export * from "./LockCoach.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports